import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { installGlobalErrorReporter } from './lib/diagnostics.js'
import { AppConfigProvider } from './config/appConfig.jsx'
import './styles.css'

installGlobalErrorReporter()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppConfigProvider>
        <App />
      </AppConfigProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
